import React from 'react';
import './gridStyle.css';

function GridRow (props) {
  function click (){
    if(props.rowClick) {
      props.rowClick(props.colNum, props.rowData)
    }
  }
 // para enviar un estilo y un width al td  {style: {color: 'red'}, print: item.description},
  if (props.data && typeof props.data === 'object' ){
    const style = props.data.style || {}
    const width = props.data.width || ''
   return(
      <td 
        className = "td-grid-class"  
        onClick = {click}
        width = {width}
        style = {style} 
        >{props.data.print}
      </td>
    )
  
  } else {
  
    return(
  
      <td className = "td-grid-class" onClick = {click} >{props.data}</td>
    )
  }
}

export default GridRow
